export const escapeRegExp = text => text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");

export const skipEmpty = reducer => (arg1, arg2) => {
	if (arg1 != null && arg2 != null) return reducer(arg1, arg2);
	if (arg1 != null) return arg1;
	return arg2;
};

export const skipEmptyMapper = mapper => arg => (arg != null ? mapper(arg) : arg);
